/**
 * Video Once Autoplay
 * - Replays autoplay videos from the beginning each time they enter the viewport
 * - Pauses when they leave the viewport
 * - Click to replay after video ends
 */
(function () {
  function init() {
    const containers = document.querySelectorAll('internal-video[data-autoplay="true"]');
    containers.forEach(setupVideo);
  }

  function setupVideo(container) {
    const video = container.querySelector('video');
    if (!video) return;

    let initialized = false;

    // Wait for the first play (handled by the built-in InternalVideo class)
    video.addEventListener('playing', function onFirstPlay() {
      if (initialized) return;
      initialized = true;
      video.removeEventListener('playing', onFirstPlay);

      let isInView = true;

      // Reset when paused externally (e.g. pauseAllMedia on slide change)
      video.addEventListener('pause', function () {
        isInView = false;
      });

      const observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            if (!isInView) {
              video.currentTime = 0;
              video.play().catch(function () {});
              container.classList.add('internal-video--playing');
            }
            isInView = true;
          } else {
            isInView = false;
            if (!video.paused) {
              video.pause();
            }
          }
        });
      }, { threshold: 0.05 });

      observer.observe(container);
    });

    // Keep last frame visible after video ends (override InternalVideo's endedVideo
    // which removes internal-video--playing and shows the play button)
    video.addEventListener('ended', function () {
      container.classList.add('internal-video--playing');
    });

    // Click to replay when ended
    container.addEventListener('click', function (e) {
      if (e.target.closest('.internal-video__play')) return;
      if (video.ended) {
        video.currentTime = 0;
        video.play().catch(function () {});
        container.classList.add('internal-video--playing');
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
